import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Clients from "@/components/Clients";
import Projects from "@/components/Projects";
import Collaborations from "@/components/Collaborations";
import Testimonials from "@/components/Testimonials";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import EOD from "@/components/EOD";
import Success from "@/components/Success";

// Landing Page Component
const LandingPage = () => {
  return (
    <main>
      <Hero />
      <About />
      <Clients />
      <Projects />
      <Collaborations />
      <Testimonials />
      <CTA />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/eod" element={<EOD />} />
          <Route path="/eod/success" element={<Success />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
